var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="@inherits Umbraco.Web.Mvc.UmbracoTemplatePage<ul class=\"list-unstyled\"><li ng-if=\"creditCard.type\"><img ng-src=\"//emuncloud-staticassets.s3.amazonaws.com/img/cc/{{creditCard.type.toLowerCase()}}.png\"/> <strong>{{creditCard.type|titlecase}}</strong></li><li>{{creditCard.number}}</li><li ng-if=\"creditCard.expirationYear\">Expires: {{creditCard.expirationMonth}}/{{creditCard.expirationYear}}</li></ul>";
var id1="credit-card-info.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;